import { __decorate, __metadata } from "tslib";
import { SupportedCurrencyEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsInt, IsNotEmpty, IsOptional, IsString, Min, ValidateNested } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
import { ReadLoyaltyPromotionConditionsDto } from './ReadLoyaltyPromotionConditionsDto';
import { ReadLoyaltyPromotionDiscountDto } from './ReadLoyaltyPromotionDiscountDto';
import { ReadLoyaltyPromotionProviderDto } from './ReadLoyaltyPromotionProviderDto';
export class ReadLoyaltyPromotionDto {
    getExternalType() {
        return this.discount.externalType;
    }
}
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDto.prototype, "title", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDto.prototype, "subTitle", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDto.prototype, "image", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    Type(() => ReadLoyaltyPromotionDiscountDto),
    IsNotEmpty({ always: true }),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadLoyaltyPromotionDiscountDto)
], ReadLoyaltyPromotionDto.prototype, "discount", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    Type(() => ReadLoyaltyPromotionConditionsDto),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadLoyaltyPromotionConditionsDto)
], ReadLoyaltyPromotionDto.prototype, "conditions", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ always: true }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDto.prototype, "currency", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    Type(() => ReadLoyaltyPromotionProviderDto),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadLoyaltyPromotionProviderDto)
], ReadLoyaltyPromotionDto.prototype, "provider", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsInt({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    Min(1, { groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    __metadata("design:type", Number)
], ReadLoyaltyPromotionDto.prototype, "priority", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsBoolean({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    __metadata("design:type", Boolean)
], ReadLoyaltyPromotionDto.prototype, "isCumulative", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsString({ each: true, groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ each: true, groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    __metadata("design:type", Array)
], ReadLoyaltyPromotionDto.prototype, "compatible", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, deprecated: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ always: true }),
    IsString({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDto.prototype, "message", void 0);
//# sourceMappingURL=ReadLoyaltyPromotionDto.js.map